import {IBaseLookup} from "./Ibase.lookup";

export namespace ModalityTypeGroup {

	export const lookupName: string = "ModalityTypeGroup";

	export interface ModalityTypeGroup {
		modalityTypeGroupKey: number;
		code: string;
		description: string;
		active: string;
		color: string;
		lastUpdated: Date;
	}

	export interface ModalityTypeGroupDS extends IBaseLookup {
		modalityTypeGroup: ModalityTypeGroup[];
	}
}
